import React from 'react';
import { Callout, CalloutProps } from './Callout';

export const Tip: React.FC<Omit<CalloutProps, 'type'>> = (props) => (
  <Callout type="tip" {...props} />
);

export default Tip;
